import { type Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { colors } from '@procore/core-react';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: '30px',
    padding: '22px 18px 18px 18px',
    borderRadius: '5px',
    boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.25)',
    [theme.breakpoints.down(1100)]: {
      width: 'calc(50% - 12px)',
      marginTop: '0',
      marginBottom: '0',
      marginLeft: '12px',
      border: '1px solid ' + colors.gray85,
      boxShadow: 'none',
    },
    [theme.breakpoints.down(600)]: {
      width: '100%',
      marginTop: '30px',
      marginLeft: 0,
      /*padding: 0,
      border: 'none',*/
    },
  },
  title: {
    marginBottom: '6px',
    fontWeight: 600,
  },
  documents: {
    [theme.breakpoints.between(600, 1100)]: {
      display: 'flex',
      flexDirection: 'column',
      height: 'calc(100% - 31px)',
    },
  },
  downloadLatest: {
    marginBottom: '12px',
    color: colors.gray45,
    fontSize: '14px',
    fontWeight: 400,
  },
  info: {
    display: 'flex',
    alignItems: 'center',
  },
  documentsLogo: {
    '& > div': {
      height: '50px',
      minHeight: '50px',
      width: '50px',
      minWidth: '50px',
      '& > img': {
        borderRadius: '3px',
      },
    },
  },
  filesInfoAndLastUpdated: {
    marginLeft: '12px',
  },
  filesInfo: {
    color: colors.gray45,
    fontSize: '14px',
    fontWeight: 400,
  },
  lastUpdated: {
    marginTop: '3px',
    color: colors.gray45,
    fontSize: '14px',
    fontWeight: 400,
  },
  buttonContainer: {
    display: 'block',
    marginTop: '12px',
    paddingTop: '12px',
    borderTop: '1px solid ' + colors.gray85,
    [theme.breakpoints.down(1100)]: {
      marginTop: 'auto',
    },
    [theme.breakpoints.down(600)]: {
      marginTop: '15px',
      /*paddingTop: 0,
      borderTop: 'none',*/
    },
  },
  disableButtonContainer: {
    pointerEvents: 'none',
  },
  button: {
    width: '100%',
  },
  biddingClosed: {
    marginTop: '10px',
    color: colors.gray45,
    fontSize: '12px',
    fontWeight: 400,
  },
  noDocumentsUploaded: {
    marginTop: '10px',
    color: colors.gray45,
    fontSize: '14px',
    fontWeight: 400,
  },
}));
